import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const TEASER_DISMISS_KEY = 'waTeaserDismissed';
const TEASER_DELAY_MS = 3000;

@Component({
    selector: 'app-whatsapp-chat',
    templateUrl: './whatsapp-chat.component.html',
    styleUrls: ['./whatsapp-chat.component.css'],
    standalone: false
})
export class WhatsappChatComponent implements OnInit, OnDestroy {

    showTeaser = false;
    teaserDismissed = true;

    private teaserTimeout: any;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

    ngOnInit(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.teaserDismissed = sessionStorage.getItem(TEASER_DISMISS_KEY) === 'true';
        if (this.teaserDismissed) {
            return;
        }
        this.teaserTimeout = setTimeout(() => {
            this.showTeaser = true;
        }, TEASER_DELAY_MS);
    }

    dismissTeaser(): void {
        this.showTeaser = false;
        this.teaserDismissed = true;
        if (isPlatformBrowser(this.platformId)) {
            sessionStorage.setItem(TEASER_DISMISS_KEY, 'true');
        }
    }

    ngOnDestroy(): void {
        if (this.teaserTimeout) {
            clearTimeout(this.teaserTimeout);
        }
    }
}
